// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import ErrorBoundary from './ErrorBoundary'
import IdleWarningBanner from './IdleWarningBanner'
import EmailVerificationBanner from './EmailVerificationBanner'

import { T, alpha } from '../theme/theme'
export default function ProtectedRoute({ children }) {
  const { user, firm, loading } = useAuth()
  const location = useLocation()

  if (loading) return (
    <div style={{
      minHeight: '100vh', background: T.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{ textAlign: 'center' }}>
        {/* BUG-N4 fix: @keyframes spin was missing — added inline style tag below */}
        <div style={{
          width: '48px', height: '48px',
          border: `3px solid ${alpha(T.or, 0.2)}`,
          borderTopColor: T.or, borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          margin: '0 auto 16px'
        }}/>
        <div style={{ fontSize: '14px', color: T.mt }}>Loading KaiLux...</div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )

  if (!user) return <Navigate to="/login" replace />

  // Orphaned-auth-user recovery (5 Sept 2026 — see kailux-fixes-log.md and
  // kailux-master-plan.md item 16): `user` is a real Supabase session, but
  // `firm` came back null because no firms/firm_users row exists at all.
  // Previously this fell straight through to `children` below and the
  // person landed in a broken app shell with no visible way out — every
  // page assumes a firm exists. Send them to the dedicated recovery page
  // instead; that page is the one exception allowed through without a firm.
  if (!firm) {
    if (location.pathname === '/signup-incomplete') {
      return (
        <ErrorBoundary>
          {children}
        </ErrorBoundary>
      )
    }
    return <Navigate to="/signup-incomplete" replace />
  }
  // A firm now exists (e.g. resolved in another tab, or right after the
  // reset-and-resignup flow completes) — no reason to stay on the
  // recovery page.
  if (location.pathname === '/signup-incomplete') {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <ErrorBoundary>
      <IdleWarningBanner />
      <EmailVerificationBanner />
      {children}
    </ErrorBoundary>
  )
}
